import { Card, CardBody, Col } from "reactstrap";
import { OutlinedTouchSpinTitle } from "../../../../../constants";
import CommonTouchSpin from "./common/CommonTouchSpin";
import { DefaultTouchSpinData, TouchSpinSubTitle } from "../../../../../data/formsAndTable/forms/FormWidgets";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const OutlinedTouchSpin = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={OutlinedTouchSpinTitle} span={TouchSpinSubTitle} />
        <CardBody className="common-flex">
          {DefaultTouchSpinData.map((data, index) => (
            <CommonTouchSpin key={index} color={data} outline={true} btnClass={`spin-border-${data}`} />
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default OutlinedTouchSpin;
